import {Component} from "../../../../../../../../sedestral/framework/interface/component/Component";
import * as s from "./community-page-blog-icon.scss";
import {CommunityPartnerType} from "../../../../../../../../models/community/types/CommunityPartnerType";

export class CommunityPageBlogIconComponent extends Component {
    constructor(partnerType: CommunityPartnerType) {
        super();
        //language=HTML
        this.template = `
            <div siteIcon class="${s.componentCommunityPageBlogIcon} ${s[CommunityPartnerType[partnerType]]}"></div>`;
    }
}